import { formatUsd, formatUsdExact } from "./format";

export function UsdAmount({ value }: { value: string }) {
  return <div className="usd-amount">
    <span>{formatUsd(value)}</span>
    <details className="usd-precision">
      <summary>Exact USD value</summary>
      <span>{formatUsdExact(value)}</span>
    </details>
  </div>;
}
